"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorReporter = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ErrorListContext_1 = require("../ErrorListContext");
/**
 * Reports an error to a containing ErrorList React Context.
 * Note that the error will remain in the ErrorList while this component remains in the tree.
 */
class ErrorReporter extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(ErrorListContext_1.ErrorListContext.Consumer, null, errorList => (react_1.default.createElement(ErrorReporterInternal, { errorCode: this.props.errorCode, errorMessage: this.props.errorMessage, errorList: errorList }))));
    }
}
exports.ErrorReporter = ErrorReporter;
class ErrorReporterInternal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.errorId = null;
    }
    componentDidMount() {
        this.reportError();
    }
    componentDidUpdate(prevProps) {
        if (this.props.errorCode !== prevProps.errorCode
            || this.props.errorMessage !== prevProps.errorMessage) {
            this.reportError();
        }
    }
    componentWillUnmount() {
        this.removeError();
    }
    render() {
        return null;
    }
    reportError() {
        this.removeError();
        this.errorId = this.props.errorList.addError(this.props);
    }
    removeError() {
        if (this.errorId != null) {
            this.props.errorList.removeError(this.errorId);
            this.errorId = null;
        }
    }
}
//# sourceMappingURL=ErrorReporter.js.map